<template>
  <div class='ats-edit-form'>
    <fieldset>
      <div v-show="!hasExistingATSData" class="field">
        <label for="company_ats_url" class="cm-label">{{ translate("activerecord.attributes.company.ats_url") }}</label>
        <input
          type="url"
          v-model="ats_url"
          id="company_ats_url"
          class="cm-field"
        />
        <aside class="cm-desc">
          <Markdown :input="translate('company_ats_url_helper_text')" />
        </aside>
      </div>

      <div v-show="ats_provider || ats_username">
        <p class="cm-notice" v-show="ats_url">{{ translate("forms.ats.autofilled_ats_properties") }}</p>
        <div class="field">
          <label class="cm-label required" for="">{{ translate("activerecord.attributes.company.ats_provider") }}</label>

          <label class="ats-edit-form__radio" v-for="provider in providers" :key="provider.value">
            <input
              name="company[ats_provider]"
              type="radio"
              :value="provider.value"
              v-model="ats_provider"
              required
            />
            {{ provider.label }}
          </label>
        </div>

        <div class="field">
          <label class="cm-label required" for="">
            {{ translate("activerecord.attributes.company.ats_username") }}
          </label>
          <input
            class="cm-field"
            name="company[ats_username]"
            type="text"
            v-model="ats_username"
            required
          />
          <Markdown
            class="cm-desc"
            :input="translate(
              'activerecord.attributes.company.ats_username_helper_text',
              {provider: activeProvider.label}
            )"
          />
        </div>
        <div v-if="ats_provider === 'greenhouse'" class="field">
          <label class="cm-label" for="">
            {{ translate("activerecord.attributes.company.ats_referral_code") }}
          </label>
          <input
            class="cm-field"
            name="company[ats_referral_code]"
            type="text"
            v-model="ats_referral_code"
          />
          <Markdown
            class="cm-desc"
            :input='translate(
              "activerecord.attributes.company.ats_referral_code_helper_text",
              {provider: activeProvider.label}
            )'
          />
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
  import {getAtsDataFromURL} from '../lib/url'
  import TranslationMixin from '../mixins/translation'
  import Markdown from './markdown.vue'
  export default {
    mixins: [TranslationMixin],

    components: {Markdown},

    props: {
      company: {
        type: Object,
      }
    },

    data () {
      return {
        ats_url: null,
        ats_provider: this.company.ats_provider,
        ats_username: this.company.ats_username,
        ats_referral_code: this.company.ats_referral_code,

        providers: [{
          label: "Greenhouse", value: "greenhouse"
        }, {
          label: "Lever", value: "lever"
        }]
      }
    },

    computed: {
      hasExistingATSData() {
        return (
          !!this.company.ats_provider ||
          !!this.company.ats_username ||
          !!this.company.ats_referral_code
        )
      },
      activeProvider() {
        return this.providers.find(p => p.value === this.ats_provider)
          || { label: "Provider" }
      }
    },

    watch: {
      ats_url(nextUrl, prevUrl) {
        const data = getAtsDataFromURL(nextUrl)

        this.ats_provider = data.provider || this.ats_provider
        this.ats_username = data.username || this.ats_username
        this.ats_referral_code = data.referral || this.ats_referral_code
      }
    },
  }
</script>

<style lang='scss' scoped>

  .ats-edit-form {
    &__radio {
      display: block;
      line-height: 2rem;
      input {
        margin-right: 0.5rem;
      }
    }
    & /deep/ p {
      margin: 0.5rem 0;
    }
    & /deep/ input {
      &:invalid {
        border: 1px solid $alert_color;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// app/javascript/components/ats-edit-form.vue?c8c08cee